(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["4S-size-chart-filter"] && !Shopify.designMode) return;
  try {
    
const brandContainer = document.querySelectorAll(".size-chart__filter--container");
const brand = document.querySelectorAll(".size-chart__filter--container__brand");
let brandName = document.querySelector(".size-chart__filter--container__brand--selected").innerText;
const table = document.querySelectorAll(".size-chart");
const verTodo = document.querySelector("#all-button")
$(brand).on("click", function (e) {
    if (e.currentTarget.classList.contains("size-chart__filter--container__brand--selected")) {
    }else {
        $(brandContainer).find(".size-chart__filter--container__brand--selected").removeClass("size-chart__filter--container__brand--selected");
        e.currentTarget.classList.add("size-chart__filter--container__brand--selected");
        brandName = document.querySelector(".size-chart__filter--container__brand--selected").innerText;
        for (let element = 0; element < table.length; element++) {
            const _table = table[element];
            if(_table.getAttribute(brandName)) {
                $(_table).removeClass("size-chart__table--hide")
            }else {
                $(_table).addClass("size-chart__table--hide")
            }
        }
    }
});
$(verTodo).on("click", function (e) {
    for (let element = 0; element < table.length; element++) {
        const _table = table[element];
        $(_table).removeClass("size-chart__table--hide")
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["4S-size-chart-table"] && !Shopify.designMode) return;
  try {
    
    let genders = document.querySelectorAll(".size-chart__table--genderSelector__container--option")
    $(genders).on("click", function (e) {
        const sizeChart = e.currentTarget.closest(".size-chart")
        let genderSelected = $(sizeChart).find(".size-chart__table--genderSelector__container--optionSelected")
        genders = $(sizeChart).find(".size-chart__table--genderSelector__container--option")
        if (e.currentTarget.classList.contains(".size-chart__table--genderSelector__container--optionSelected")) {

        }else {
            
            for (let gender = 0; gender < genders.length; gender++) {
                const element = genders[gender];
                element.classList.remove("size-chart__table--genderSelector__container--optionSelected")
            }
            e.currentTarget.classList.add("size-chart__table--genderSelector__container--optionSelected")
            genderSelected = $(sizeChart).find(".size-chart__table--genderSelector__container--optionSelected").attr("id")
        }

    const manTables = $(sizeChart).find(".size-chart__table--container__table--man")
    const womanTables = $(sizeChart).find(".size-chart__table--container__table--woman")
    const childTables = $(sizeChart).find(".size-chart__table--container__table--child")
    if(genderSelected == "man"){
        for (let table = 0; table < womanTables.length; table++) {
            const _table = womanTables[table];
            _table.classList.add("table-hide")
        }
        for (let table = 0; table < childTables.length; table++) {
            const _table = childTables[table];
            _table.classList.add("table-hide")
        }
        for (let table = 0; table < manTables.length; table++) {
            const _table = manTables[table];
            if($(_table).hasClass("table-hide")){
                _table.classList.remove("table-hide")
            }
        }
    }else if(genderSelected == "woman"){
        for (let table = 0; table < manTables.length; table++) {
            const _table = manTables[table];
            _table.classList.add("table-hide")
        }
        for (let table = 0; table < childTables.length; table++) {
            const _table = childTables[table];
            _table.classList.add("table-hide")
        }
        for (let table = 0; table < womanTables.length; table++) {
            const _table = womanTables[table];
            if($(_table).hasClass("table-hide")){
                _table.classList.remove("table-hide")
            }
        }
    }else {
        for (let table = 0; table < manTables.length; table++) {
            const _table = manTables[table];
            _table.classList.add("table-hide")
        }
        for (let table = 0; table < womanTables.length; table++) {
            const _table = womanTables[table];
            _table.classList.add("table-hide")
        }
        for (let table = 0; table < childTables.length; table++) {
            const _table = childTables[table];
            if($(_table).hasClass("table-hide")){
                _table.classList.remove("table-hide")
            }
        }
    }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();
})();
